import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import HtmlContentFromApi from '@r1-frontend/ui-react/components/HtmlContentFromApi';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { TickCircle } from '@r1-frontend/ui-react/components/svg/main';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

type TSubscriptionsPopup = {
    displayImage: string,
    description: string[],
    title: string,
    onClose: () => void,
    isOpen: boolean,
}
const SubscriptionsAdditionalInfoPopup = ({ displayImage, description, isOpen, title, onClose, ...props }: TSubscriptionsPopup) => {
    return (
        <DefaultPopup
            isOpen={isOpen}
            fullWidth={false}
            onClose={onClose}
            {...props}
        >
            <ST.ImageBlock src={displayImage} alt={`Изображение ${title}`} visibleByDefault/>
            <IndentContainer $desktop={[32]} $mobile={[24]}>
                <H3>{title}</H3>
                <ListContainer $size={16}>
                      {description.map((item: string, index: number) =>
                        <ST.BenefitsText key={index}>
                            <TickCircle size={20} />
                            <Paragraph4 $color={COLORS.TextInfo}>
                                <HtmlContentFromApi>
                                    {item}
                                </HtmlContentFromApi>
                            </Paragraph4>
                        </ST.BenefitsText>)
                      }
                </ListContainer>
                <ButtonGroup>
                    <Button
                        bType={'action'}
                        size={'medium'}
                        onClick={onClose}
                    >
                        Закрыть
                    </Button>
                </ButtonGroup>
            </IndentContainer>
        </DefaultPopup>
    );
};

export default styled(SubscriptionsAdditionalInfoPopup)`
    ${ListContainer} {
        margin-bottom: 16px;
    }
`;
